export default {
  headline: 'Modell unterstützt kein Stickstoff',
  text: 'Das gewählte Rezept benötigt Stickstoff, aber das Modell bietet keine Stickstoffkapazität. Bitte wählen Sie ein anderes Modell oder Rezept.',
};
